var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6851 10.3333C15.6851 9.7983 15.2641 9.36458 14.7448 9.36458C14.2255 9.36458 13.8046 9.7983 13.8046 10.3333V13.2396H10.9838C10.4645 13.2396 10.0435 13.6733 10.0435 14.2083C10.0435 14.7434 10.4645 15.1771 10.9838 15.1771H13.8046V18.0833C13.8046 18.6184 14.2255 19.0521 14.7448 19.0521C15.2641 19.0521 15.6851 18.6184 15.6851 18.0833V15.1771H18.5059C19.0251 15.1771 19.4461 14.7434 19.4461 14.2083C19.4461 13.6733 19.0251 13.2396 18.5059 13.2396H15.6851V10.3333Z",
    fill: "#85FAC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7448 1.61458C7.99406 1.61458 2.52148 7.25299 2.52148 14.2083C2.52148 21.1637 7.99406 26.8021 14.7448 26.8021C21.4956 26.8021 26.9682 21.1637 26.9682 14.2083C26.9682 7.25299 21.4956 1.61458 14.7448 1.61458ZM4.402 14.2083C4.402 8.32304 9.03264 3.55208 14.7448 3.55208C20.457 3.55208 25.0877 8.32304 25.0877 14.2083C25.0877 20.0936 20.457 24.8646 14.7448 24.8646C9.03264 24.8646 4.402 20.0936 4.402 14.2083Z",
    fill: "#85FAC6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.224 23.6352C24.8568 23.2569 24.2615 23.2569 23.8943 23.6352C23.5271 24.0135 23.5271 24.6269 23.8943 25.0052L28.9089 30.1718C29.2761 30.5501 29.8714 30.5501 30.2386 30.1718C30.6058 29.7935 30.6058 29.1801 30.2386 28.8018L25.224 23.6352Z",
    fill: "#85FAC6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIcon);
export default __webpack_public_path__ + "static/media/ZoomIcon.4a9c62c98129d96d7693ab97d6dc43ac.svg";
export { ForwardRef as ReactComponent };